import {
  allDepthOfKnowledgeMap,
  allDepthOfKnowledgeMapAI,
} from '@edulastic/constants/const/question'
import {
  MULTIPLE_CHOICE,
  MULTIPLE_SELECTION,
  TRUE_OR_FALSE,
} from '@edulastic/constants/const/questionType'
import { ALL_PA_GRADES } from '@edulastic/constants/const/pear'
import { pdl } from '@edulastic/constants'

const { ALL_SUBJECT_NAMES } = pdl

const allGrades = ALL_PA_GRADES.map(({ description, code }) => ({
  value: code,
  text: description,
}))

const allSubjects = ALL_SUBJECT_NAMES.map((name) => ({
  value: name,
  text: name,
}))

const allTags = [
  { value: 'tag1', text: 'Tag1' },
  { value: 'tag2', text: 'Tag2' },
]

const allCollections = [
  { value: 'Private', text: 'Private' },
  { value: 'Public', text: 'Public' },
  // { value: "edulastic_certified", text: "Pear Assessment Certified" }
]

const allDepthOfKnowledge = Object.values(allDepthOfKnowledgeMap)

// First value is the default value.
const allAuthorDifficulty = [
  { value: '', text: 'All Levels' },
  { value: 'Easy', text: 'Easy' },
  { value: 'Medium', text: 'Medium' },
  { value: 'Hard', text: 'Hard' },
]

const openPolicy = [
  { value: 'Automatically on Start Date', text: 'Automatically on Start Date' },
  { value: 'Open Manually in Class', text: 'Open Manually in Class' },
]

const openPolicyForAdmin = [
  { value: 'Automatically on Start Date', text: 'Automatically on Start Date' },
  { value: 'Open Manually by Teacher', text: 'Open Manually by Teacher' },
  { value: 'Open Manually by Admin', text: 'Open Manually by Admin' },
]

const closePolicy = [
  { value: 'Automatically on Due Date', text: 'Automatically on Close Date' },
  { value: 'Close Manually in Class', text: 'Close Manually in Class' },
]

const closePolicyForAdmin = [
  { value: 'Automatically on Due Date', text: 'Automatically on Close Date' },
  { value: 'Close Manually by Admin', text: 'Close Manually by Admin' },
]

const allStatus = [
  { value: '', text: 'All' },
  { value: 'published', text: 'Published' },
  { value: 'draft', text: 'Draft' },
]

const extraStatus = [
  { value: 'inreview', text: 'In Review' },
  { value: 'rejected', text: 'Rejected' },
]

const defaultStandards = {
  Mathematics: 212,
  ELA: 213,
  Science: 215,
  'Social Studies': 236,
}

const allQuestionTypes = [
  { value: MULTIPLE_CHOICE, text: 'Multiple Choice question' },
  { value: TRUE_OR_FALSE, text: 'True or False' },
  { value: MULTIPLE_SELECTION, text: 'Multiple Select question' },
]

const allDepthOfKnowledgeAI = Object.values(allDepthOfKnowledgeMapAI)

export default {
  allGrades,
  allSubjects,
  allTags,
  allCollections,
  allDepthOfKnowledge,
  allAuthorDifficulty,
  openPolicy,
  openPolicyForAdmin,
  closePolicy,
  closePolicyForAdmin,
  allStatus,
  defaultStandards,
  extraStatus,
  allQuestionTypes,
  allDepthOfKnowledgeAI,
  ALL_SUBJECT_NAMES,
}
